<template>
  <div>
    <el-form-item label="应用名称" prop="app_name">
      <el-input v-model="data.app_name"></el-input>
    </el-form-item>
    <el-form-item label="最大连接数" prop="max_link_length">
      <el-input-number v-model="data.max_link_length" :min="100" :step="10"></el-input-number>
    </el-form-item>
    <el-form-item label="过期时间" prop="timeout_at">
      <el-date-picker v-model="data.timeout_at" type="date" placeholder="选择日期"></el-date-picker>
    </el-form-item>
    <el-form-item label="应用类型" prop="app_type">
      <el-input v-model="data.app_type"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
      default: function() {
        return {};
      }
    }
  }
};
</script>

<style>
</style>